/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Accept_ButtonInputs */

const en_applicants_bulk_accept_button = /** @type {(inputs: Applicants_Bulk_Accept_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const de_applicants_bulk_accept_button = /** @type {(inputs: Applicants_Bulk_Accept_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annehmen`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Applicants_Bulk_Accept_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_accept_button = /** @type {((inputs?: Applicants_Bulk_Accept_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Accept_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_accept_button(inputs)
	return en_applicants_bulk_accept_button(inputs)
});